export const GENERAL = {
  VAT: 8.1,
};
